import { toastr } from "react-redux-toastr";
import { client_v2, stringifyQuery } from "utils/api";

export const toggleFilters = () => (dispatch) =>
  dispatch({ type: "CARTS_TOGGLE_FILTERS" });

export const resetFilters = () => (dispatch) =>
  dispatch({ type: "CARTS_RESET_FILTERS" });

export const filterCarts = (query) => async (dispatch) =>
  dispatch({ type: "CARTS_SET_FILTERS_QUERY", query });

export const getCarts = ({
  page = 1,
  per_page = 50,
  ...rest
}) => async (dispatch, getState) => {
  try {
    const {
      status,
      filters: { query },
    } = getState().carts;

    dispatch({
      type:
        status === "invalid"
          ? "CARTS_LOADING"
          : "CARTS_SEARCHING",
    });

    const { data, meta } = await client_v2.get(
      `/carts?${stringifyQuery({
        ...rest,
        page,
        per_page,
        ...query,
      })}`
    );

    dispatch({
      type: "CARTS_SUCCESS",
      data,
      meta,
    });
  } catch (error) {
    dispatch({ type: "CARTS_FAILURE" });
    toastr.error(
      "Błąd",
      "Wystąpił błąd podczas pobierania"
    );
  }
};

export const updateCart = (id, { is_occupied }) => async (
  dispatch
) => {
  try {
    await client_v2.put(`/carts/${id}`, { is_occupied });
    dispatch({ type: "CART_UPDATED", id, is_occupied });
  } catch (error) {
    toastr.error(
      "Błąd",
      "Wystąpił błąd podczas aktualizowania"
    );
    throw error;
  }
};
